module.exports = __webpack_public_path__ + "static/img/content-bg2.962657e9.jpg";